import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

export default class Item extends React.PureComponent {
  render() {
    const {
      title,
      location,
      slug,
      isLoading,
    } = this.props;

    return (
      <InView
        rootMargin="16px 0px"
        triggerOnce
      >
        {({ inView, ref }) => (
          <article
            ref={ref}
            className={`Item ${
              inView && !isLoading ? 'Item--active' : ''
            } ${
              isLoading ? 'Item--loading' : ''
            }`}
          >
            <h2 className="Item__title">
              <Link
                to={slug}
                className="Item__link"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: title || 'Loading' }}
              />
            </h2>
            {location && (
              <p
                className="Item__location"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: location }}
              />
            )}
          </article>
        )}
      </InView>
    );
  }
}

Item.propTypes = {
  title: PropTypes.string,
  location: PropTypes.string,
  slug: PropTypes.string,
  isLoading: PropTypes.bool,
};

Item.defaultProps = {
  title: '',
  location: '',
  slug: '',
  isLoading: false,
};
